<template>
  <div v-if="items.length" class="items">
    <section>
      <v-container class="px-lg-8">
        <TitleWidget dark>
          {{ title }}
        </TitleWidget>

        <v-row class="mt-7 mt-lg-9 mx-lg-n8 grid-list" justify="center">
          <template v-for="(item, keyItems) in items">
            <v-col :key="keyItems" class="px-lg-8" cols="6" md="4" lg="3">
              <ProjectCard v-bind="item" />
            </v-col>
          </template>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ProjectCard from "../cards/ProjectCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _config = {
  mod: "projects",
  path: "/projetos",
};

const _data = {
  title: "Projetos",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ img, title }) => ({
        img: img.featured,
        title,
        to: `${_config.path}/${formatToURL(title)}`,
      }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    ProjectCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  background-image: url(../../assets/img/project-bg.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .grid-list {
    gap: 16px 0;
  }
}
</style>
